// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XzcR","colMin":"styles_colMin__1QbFd"};